import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { reset, setLoading, setProduct } from './actions';

const productReducer = handleActions(
  {
    [setProduct.toString()]: (_, { payload: product }) => product,
    [reset.toString()]: () => ({})
  },
  {}
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  product: productReducer,
  loading: loadingReducer
});
